import { __decorate, __metadata } from "tslib";
import { Component, Inject, Model, Prop, Watch } from "vue-property-decorator";
import { SYM_LV_FORM_ITEM } from "../form-item/LvFormItem.vue";
import { SYM_LV_RADIO_BUTTON_GROUP } from "../radio-button-group/LvRadioButtonGroup.vue";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvRadioButton";
let LvRadioButton = class LvRadioButton extends UIComponent {
    constructor() {
        super(...arguments);
        this.radioDisplayValue = null;
    }
    onModelChange(newValue, oldValue) {
        if (newValue == oldValue)
            return;
        this.radioDisplayValue = newValue == this.value ? newValue : null;
    }
    get targetModelProperty() {
        return this.formItem?.prop;
    }
    onRadioDisplayStateChange() {
        this.$emit("change", this.radioDisplayValue);
        if (this.radioDisplayValue == this.value) {
            this.$emit("checked");
        }
        else {
            this.$emit("unchecked");
        }
    }
};
__decorate([
    Inject({ default: null, from: SYM_LV_FORM_ITEM }),
    __metadata("design:type", Object)
], LvRadioButton.prototype, "formItem", void 0);
__decorate([
    Inject({ default: null, from: SYM_LV_RADIO_BUTTON_GROUP }),
    __metadata("design:type", Object)
], LvRadioButton.prototype, "radioButtonGroup", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Object)
], LvRadioButton.prototype, "value", void 0);
__decorate([
    Model("change"),
    __metadata("design:type", Object)
], LvRadioButton.prototype, "model", void 0);
__decorate([
    Watch("model", { immediate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], LvRadioButton.prototype, "onModelChange", null);
LvRadioButton = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvRadioButton);
export default LvRadioButton;
//# sourceMappingURL=script.js.map